import {PageTemplate} from "../../shared/layout/PageTemplate";
import {UsersContent} from "./components/UsersContent";

export function Users() {
    return <PageTemplate pageName="Users" title="Tenders" content={<UsersContent/>}/>
}